<template>
  <div>
    <Molded>
      <b-row>
        <b-col sm="12">
          <InputText
            title="Identificação Interna"
            field="identificacao"
            :formName="formName"
            :required="true"
            :maxLength="100"
            v-model="taxation.identificacao"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4">
          <b-row>
            <b-col sm="10">
              <InputText
                :title="titleCodigoServico"
                field="codigo"
                :formName="formName"
                :maxLength="50"
                v-model="taxation.codigo"
              />
            </b-col>
            <div class="step-by-step-opcoes">
              <OpcoesFiscaisGoverno
                :modalTitle="titleCodigoServico"
                :options="optionsCodigoServico"
                buttonTitle="Ver opções"
                :onlyNumber="true"
                v-model="taxation.codigo"
              />
            </div>
          </b-row>
        </b-col>
        <b-col sm="4">
          <b-row>
            <b-col sm="10">
              <InputText
                :title="titleCodigoTributacao"
                field="codigoTributacao"
                :formName="formName"
                :required="false"
                :maxLength="50"
                v-model="taxation.codigoTributacao"
              />
            </b-col>
            <div class="step-by-step-opcoes">
              <OpcoesFiscaisGoverno
                :modalTitle="titleCodigoTributacao"
                :options="optionsCodigoTributacao"
                buttonTitle="Ver opções"
                :onlyNumber="true"
                v-model="taxation.codigoTributacao"
              />
            </div>
          </b-row>
        </b-col>
        <b-col sm="4">
          <b-row>
            <b-col sm="10">
              <InputText
                title="NBS"
                field="nbs"
                :formName="formName"
                :required="false"
                :maxLength="100"
                v-model="taxation.nbs"
              />
            </b-col>
            <div class="step-by-step-opcoes">
              <OpcoesFiscaisGoverno
                modalTitle="NBS (Nomenclatura Brasileira de Serviços)"
                :options="optionsNbs"
                buttonTitle="Ver códigos NBS"
                :onlyNumber="true"
                v-model="taxation.nbs"
              />
            </div>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4">
          <InputText
            title="CNAE"
            field="cnae"
            :formName="formName"
            :required="false"
            :maxLength="50"
            v-model="taxation.cnae"
          />
        </b-col>
        <b-col sm="2">
          <InputNumber
            title="Alíquota ISS %"
            field="aliquota"
            type="float"
            :formName="formName"
            :required="false"
            :maxLength="9"
            v-model="taxation.aliquota"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <TextArea
            title="Descrição Padrão"
            field="descricao"
            :formName="formName"
            :required="true"
            :maxLength="2000"
            v-model="taxation.discriminacao"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <small
            class="title title-parameter"
            @click="openModal(modalParametersName)"
          >
            <i class="fa-solid fa-bracket-curly"></i>
            <i class="fa-solid fa-bracket-curly"></i>
            Parâmetros
            <i class="fa-solid fa-bracket-curly-right"></i>
            <i class="fa-solid fa-bracket-curly-right"></i>
          </small>
        </b-col>
      </b-row>
    </Molded>

    <Modal
      title="Parâmetros Disponíveis"
      :width="900"
      :height="750"
      v-if="showModal(modalParametersName)"
      :onHideModal="closeParametersModal"
    >
      <ParametersInfo :params="parametersInfoParams" />
    </Modal>
  </div>
</template>

<script>
import Molded from "@nixweb/nixloc-ui/src/component/layout/Molded.vue";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import InputNumber from "@nixweb/nixloc-ui/src/component/forms/InputNumber";
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";
import TextArea from "@nixweb/nixloc-ui/src/component/forms/TextArea";
import OpcoesFiscaisGoverno from "../shared/OpcoesFiscaisGoverno.vue";
import ParametersInfo from "../../shared/ParametersInfo.vue";

import Taxation from "@/components/modules/tax-document/taxation/Taxation.js";
import Helpers from "../shared/Helpers.js";
import taxationParameters from "../../shared/parameters/taxationParameters";

import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "TaxationCreateUpdate",
  props: {
    registerInSelect: Boolean,
    value: Object,
  },
  components: {
    Molded,
    Modal,
    InputText,
    InputNumber,
    TextArea,
    OpcoesFiscaisGoverno,
    ParametersInfo,
  },
  data() {
    return {
      id: this.$route.params.id,
      formName: "taxationCreateUpdate",
      taxation: new Taxation(),
      urlCreate: "/api/v1/tax-document/taxation/create",
      urlUpdate: "/api/v1/tax-document/taxation/update",
      urlGetById: "/api/v1/tax-document/taxation/get-by-id",
      urlGetConfigCompanyById: "/api/v1/tax-document/config-company/get-by-id",
      isNacional: true,
      modalParametersName: "parametersInfoTaxation",
      parametersInfoParams: taxationParameters,
    };
  },
  mounted() {
    this.getConfigCompany();
    if (this.id) {
      this.getById();
    }
  },
  computed: {
    ...mapGetters("generic", ["event", "showModal"]),
    titleCodigoServico() {
      return this.isNacional
        ? "Código de Tributação Nacional"
        : "Código LC 116";
    },
    titleCodigoTributacao() {
      return this.isNacional
        ? "Código de Tributação Municipal"
        : "Código Tributação";
    },
    optionsCodigoServico() {
      return this.isNacional
        ? Helpers.codigoTributacaoNacional
        : Helpers.codigoLC116;
    },
    optionsCodigoTributacao() {
      return this.isNacional
        ? Helpers.codigoTributacaoNacional
        : Helpers.codigoLC116;
    },
    optionsNbs() {
      return Helpers.nbs;
    },
  },
  methods: {
    ...mapActions("generic", ["postApi", "putApi", "getApi"]),
    ...mapMutations("generic", [
      "removeLoading",
      "hideVodal",
      "openModal",
      "hideModal",
    ]),
    create() {
      const params = { url: this.urlCreate, obj: this.taxation };
      this.postApi(params).then((response) => {
        if (response.success && this.registerInSelect) {
          this.$emit("input", {
            id: response.content.id,
            content: response.content.name,
          });
          this.hideVodal(this.formName);
        }

        if (response.success && !this.registerInSelect) {
          this.id = response.content.id;
          this.$router.replace({
            name: "taxationUpdate",
            params: { id: response.content.id },
          });
        }

        this.removeLoading(["saveSaveCancel"]);
      });
    },
    update() {
      const params = { url: this.urlUpdate, obj: this.taxation };
      this.putApi(params).then(() => {
        this.removeLoading(["saveSaveCancel"]);
      });
    },
    getById() {
      const params = { url: this.urlGetById, obj: { id: this.id } };
      this.getApi(params).then((response) => {
        if (response.success && response.content) {
          this.taxation.update(response.content);
        }
        this.removeLoading(["panel"]);
      });
    },
    getConfigCompany() {
      const params = { url: this.urlGetConfigCompanyById, obj: {} };
      this.getApi(params).then((response) => {
        if (response.success && response.content) {
          this.isNacional = !!response.content.nacional;
        }
      });
    },
    closeParametersModal() {
      this.hideModal(this.modalParametersName);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "saveSaveCancel" && !this.registerInSelect) {
          if (!this.id) this.create();
          if (this.id) this.update();
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.step-by-step-opcoes {
  margin-top: 20px;
}

.title-parameter {
  font-size: 12px;
  cursor: pointer;
  color: darkblue;
}
</style>
